const isEasingGenerator = (easing) => typeof easing === "object" &&
    Boolean(easing.createAnimation);

export { isEasingGenerator };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/is-easing-generator.es.js
// module id = AugK
// module chunks = 0